'use client'

import { useTranslation } from "react-i18next";
import { Facebook, Linkedin, Twitter, Instagram, Send, Youtube } from 'lucide-react';
import { useFooterDisclaimer } from '@/core/hooks/useFooterDisclaimer';

const socialLinks = [
  {
    icon: Facebook,
    link: 'https://www.facebook.com/LordToken.off',
  },
  {
    icon: Linkedin,
    link: 'https://www.linkedin.com/company/lordtoken-pro/',
  },
  {
    icon: Twitter,
    link: 'https://x.com/LordToken_off',
  },
  {
    icon: Instagram,
    link: 'https://www.instagram.com/lordtoken_off/',
  },
  {
    icon: Send,
    link: 'https://t.me/LordTokenGroupe',
  },
  {
    icon: Youtube,
    link: 'https://www.youtube.com/@LordToken',
  },
]

export default function Footer() {
  const { t } = useTranslation();
  const { content } = useFooterDisclaimer();

  return (
    <div className="footer">
      <span className="footer__content">
        {content}
      </span>
      {/* Section copyright masquée temporairement
      <div className="footer-copyright">
        <span>{t('footer.copyright')}</span>
        <div className="footer-social-links">
          {
            socialLinks.map(({ icon: Icon, link }) => (
              <a href={link} key={link} target="_blank" rel="noopener noreferrer" className="social-link">
                <Icon size={20} />
              </a>
            ))
          }
        </div>
      </div>
      */}
    </div>
  )
}